import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditConferencePayload } from '@app-store/slices/conferences/editConference'

interface TaskAction extends Action {
    payload: IEditConferencePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.conferences.edit

function* editConferenceSagaTask({ payload }) {
    try {
        const response = yield axios.patch(`/event/conference/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editConferenceSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editConferenceSagaTask)
}

export default editConferenceSaga
